import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FilterService } from 'app/services/filter.service';
import { HeaderService } from 'app/services/header.service';
import { Subscription } from 'rxjs';
import { TreemapChartComponent } from './treemap-chart/treemap-chart.component';
import { IExportableChart } from 'app/utils/pdf.utils';
import { CitationChartsService } from 'app/services/citation-charts.service';
import { IChartValuePoint } from 'app/models/citation-charts.models';
import { PageType } from 'app/models/pdf.models';
import { PdfService } from 'app/services/pdf.service';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CardComponent } from '../../shared/card/card.component';

@Component({
  selector: 'app-treemap',
  templateUrl: './treemap.component.html',
  styleUrls: ['./treemap.component.scss'],
  imports: [NgIf, MatProgressSpinner, CardComponent, TreemapChartComponent],
})
export class TreemapComponent implements OnInit, OnDestroy {
  citationCounts: IChartValuePoint[] = [];
  loading = false;

  @ViewChild(TreemapChartComponent)
  treemapChart!: TreemapChartComponent;

  treemapChartTitle = 'Violation Counts - Treeview';

  private exportSubscripton!: Subscription;
  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private citationChartsService: CitationChartsService,
    private filterService: FilterService,
    private headerService: HeaderService,
    private pdfService: PdfService,
  ) {}

  ngOnInit(): void {
    this.getViolationsCounts();

    const filters = this.filterService.applyFiltersChange.subscribe(() => {
      this.getViolationsCounts();
    });
    this.subscriptions.add(filters);

    this.exportSubscripton = this.headerService.exportChange.subscribe(() => {
      this.exportToPdf();
    });
  }

  ngOnDestroy(): void {
    this.exportSubscripton.unsubscribe();
    !!this.subscriptions && this.subscriptions.unsubscribe();
  }

  private getViolationsCounts() {
    const { filters } = this.filterService;

    this.loading = true;
    this.citationChartsService.getTreeviewViolations(filters).subscribe((result) => {
      this.loading = false;
      this.citationCounts = result?.length > 0 ? result[0].values : [];
    });
  }

  exportToPdf() {
    const charts: IExportableChart[] = [
      {
        chart: this.treemapChart.exportToImage(),
        name: this.treemapChartTitle,
      },
    ];
    this.pdfService.generateChartReportFile(
      PageType.TREEMAP,
      charts,
      this.filterService.filters,
      'tda_treeview',
      'Violation Counts - Treeview',
    );
  }
}
